<script lang="ts" setup>
import { toRefs } from 'vue';
import { AttendeeDropdownOptionInterface, AttendeeSessionTypesData, DropdownOptionInterface } from '@/types';
import { EMIT } from '@/enum';
import SelectButton from 'primevue/selectbutton';

interface Props {
  attendee: AttendeeDropdownOptionInterface;
  eventSessionTypes: DropdownOptionInterface[];
  selectedSessionType: AttendeeSessionTypesData;
}

const emit = defineEmits<{
  (e: EMIT.UPDATE, value: AttendeeSessionTypesData): void;
}>();

const props = defineProps<Props>();

const { attendee, selectedSessionType, eventSessionTypes } = toRefs(props);

const checkDisabled = (sessionTypeId: number) => {
  const attendeeSessionType = attendee.value.disciplines[0].treatment_service_type?.id;
  const regularSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Regular')?.value;
  const makeupSessionTypeId = eventSessionTypes.value.find((sessionType) => sessionType.name === 'Make up')?.value;

  return !(
    attendeeSessionType === sessionTypeId ||
    sessionTypeId === regularSessionTypeId ||
    sessionTypeId === makeupSessionTypeId
  );
};
</script>

<template>
  <div class="inline-flex justify-content-between align-items-center w-full">
    <span class="text-sm" v-text="attendee.name" />
    <SelectButton
      v-model="selectedSessionType.therapy_session_type.id"
      :options="eventSessionTypes"
      :option-disabled="(option) => checkDisabled(option.value)"
      :data-key="selectedSessionType.therapy_session_type.id + attendee.name"
      option-label="acronym"
      option-value="value"
      class="inline-flex gap-2 border-none"
      @change="emit(EMIT.UPDATE, selectedSessionType)"
    >
      <template #option="slotProps">
        <div class="therapy-session-type font-semibold">
          <div>{{ slotProps.option.acronym }}</div>
        </div>
      </template>
    </SelectButton>
  </div>
</template>

<style lang="scss" scoped>
:deep(.p-selectbutton) {
  .p-button {
    border: none;
    border-radius: 4px !important;
    max-width: 44px;
    height: 26px;
    justify-content: center;
    .therapy-session-type {
      color: var(--gray-700);
    }
    &.p-highlight {
      background: var(--primary-color-light);
      .therapy-session-type {
        color: var(--primary-color-dark);
      }
    }
    &.p-disabled {
      .therapy-session-type {
        color: var(--gray-200);
      }
    }
  }
}
</style>
